document.querySelectorAll('[data-widget]').forEach((widget) => {
    const widgetAvoidSelector = widget.getAttribute('data-widget') as string

    interface IObserverOptions {
        root: Element | Document | null
        rootMargin: string
        threshold: number | number[]
    }

    window.addEventListener('load', () => {
        // Init intersection observer to handle init, if slider is in viewport
        if ('IntersectionObserver' in window) {
            // Create options for observer
            const observerOptions: IObserverOptions = {
                root: null,
                rootMargin: `0px`,
                threshold: 0.2,
            }

            const widgetObserver = new IntersectionObserver((entries) => {
                // Handle all entries (all images in this case)
                entries.forEach((entry) => {
                    let shouldBeShown = true

                    if (entry.isIntersecting) {
                        shouldBeShown = false
                    }

                    if (shouldBeShown) {
                        widget.classList.remove('absolute')
                        widget.classList.add('fixed')
                    } else {
                        widget.classList.add('absolute')
                        widget.classList.remove('fixed')
                    }
                })
            }, observerOptions)

            // Choose element to observe
            const elementToObserve = document.querySelectorAll(widgetAvoidSelector)
            console.log(elementToObserve)

            if (elementToObserve.length) {
                elementToObserve.forEach((element) => {
                    widgetObserver.observe(element)
                })
            }
        }
    })
})